import React, { Component }  from 'react';
import { Modal, ModalHeader, ModalBody,  } from 'reactstrap';
import LocateUs from './LocateUsComponent';
import { Link } from 'react-router-dom';

class Footer extends Component {
    constructor(props) {
        super (props)
        this.state = {             
             isModal3Open: false,
        };       
        this.toggleModal3 = this.toggleModal3.bind(this);
    }  

  toggleModal3() {
        this.setState({
         isModal3Open: !this.state.isModal3Open
        });
    }

    callUs() {
        window.location.href='tel:19546968255';
    }
    
    render () {
        return (
            <React.Fragment>           
                <footer>
                <div className="row">             
                    <div className="col-4 col-sm-2 offset-1">
                        <h5>Links</h5>
                        <ul className="list-unstyled">
                            <li><Link to='/home'>Home</Link></li>
                            <li><Link to='/services'>Services</Link></li>
                            <li><Link to='#' onClick={this.callUs}>Call Us</Link></li>                            
                            <li><Link to='#' onClick={this.toggleModal3}>Locate Us</Link></li>
                        </ul>
                    </div>
                    <div className="col-6 col-sm-3 text-center">
                        <h5>Social</h5>
                        <a className="btn btn-social-icon btn-instagram" href="http://instagram.com/"><i className="fa fa-instagram" /></a>{' '}
                        <a className="btn btn-social-icon btn-facebook" href="http://www.facebook.com/"><i className="fa fa-facebook" /></a>{' '}
                        <a className="btn btn-social-icon btn-twitter" href="http://twitter.com/"><i className="fa fa-twitter" /></a>{' '}
                        <a className="btn btn-social-icon btn-google" href="http://youtube.com/"><i className="fa fa-youtube" /></a> 
                    </div>
                    <div className="col-sm-4 text-center">
                        <a role="button" className="btn btn-link" href="tel:+19546968255"><i className="fa fa-phone" /> 1-954-479-1402</a><br />
                        <a role="button" className="btn btn-link" href="mailto:leovelasquez250@hotmail.com?subject=Mail from Remodeling and Painting Website"><i className="fa fa-envelope-o" /> leovelasquez250@hotmail.com</a>
                    </div>
                </div>
                </footer>                  
                <Modal className="modal-dialog modal-lg" id="locateUs" isOpen={this.state.isModal3Open} toggle={this.state.toggle3Modal}>
                    <ModalHeader toggle={this.toggleModal3}>
                        Locate Us!
                    </ModalHeader>
                    <ModalBody>
                    <div className="container-fluid">
                            <div row>
                                <div col>
                                        <LocateUs />
                                </div>
                            </div>                    
                        </div>
                    </ModalBody>               
                </Modal>            
            </React.Fragment>           
        );
    }     
}

export default Footer;